import React from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, makeStyles } from '@material-ui/core';
import MuiLink from '@material-ui/core/Link';

import { ReactComponent as DeleteIcon } from '../assets/delete.svg';
import { ReactComponent as DownloadDataIcon } from '../assets/download.svg';
import { ReactComponent as ContactIcon } from '../assets/contact.svg';
import { ITheme } from '../../../../style/theme';

const useStyles = makeStyles((theme: ITheme) => ({
  icon: {
    marginRight: theme.spacing(1),
  },
  actionItems: {
    display: 'block',
    padding: '16px 0',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      paddingTop: '42px 0',
    },
  },
  actionItem: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '12px',
    },
  },
  actionLabel: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    paddingRight: 24,
    alignItems: 'center',
  },
}));

const DownloadExport = ({
  onDownloadAction,
  onExportAction,
}: {
  onDownloadAction: any;
  onExportAction: any;
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.actionItems}>
      <Box className={classes.actionItem}>
        <ContactIcon className={classes.icon} />
        <MuiLink
          href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}
          variant="body1"
          underline="none"
          className={classes.actionLabel}
        >
          {t('DownloadExport.contactUs')}
        </MuiLink>
      </Box>
      <Box className={classes.actionItem}>
        <DownloadDataIcon className={classes.icon} />
        <MuiLink
          href="#"
          onClick={(event: { preventDefault: () => void }) => {
            event.preventDefault();
            onExportAction();
          }}
          variant="body1"
          underline="none"
          className={classes.actionLabel}
        >
          {t('DownloadExport.exportData')}
        </MuiLink>
      </Box>
      <Box className={classes.actionItem}>
        <DeleteIcon className={classes.icon} />
        <MuiLink
          href="#"
          onClick={(event: { preventDefault: () => void }) => {
            event.preventDefault();
            onDownloadAction();
          }}
          variant="body1"
          underline="none"
          className={classes.actionLabel}
        >
          {t('DownloadExport.deleteAccount')}
        </MuiLink>
      </Box>
    </Box>
  );
};

DownloadExport.propTypes = {
  onExportAction: PropTypes.func.isRequired,
  onDownloadAction: PropTypes.func.isRequired,
};

export default DownloadExport;
